import React, {Fragment, useState} from "react";
import {withNamespaces} from "react-i18next";
import {Table} from "react-bootstrap";
import ReactPaginate from 'react-paginate';
import {usePagination, useSortBy, useTable, useFilters, useExpanded} from 'react-table'
import Filter from "./FilterField/Filter";
import InputFilter from "./FilterField/InputFilter";
import PaginationModel from "../models/HilightTableAdvanced/PaginationModel";
import SortByModel from "../models/HilightTableAdvanced/SortByModel";

const defaultGetTrProps = (state, rowInfo, column) => {};
const defaultOnClickRow = (e, row) => {};

const HilightTableAdvanced = (
    {
        t,
        columns,
        data,
        fetchData,
        loading,
        filterModel,
        itemCount,
        pageCount: controlledPageCount,
        getTrProps = defaultGetTrProps,
        onClickRow = defaultOnClickRow,
        renderRowSubComponent
    }) => {

    const [selected] = useState(null);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        visibleColumns,
        page,
        pageCount,
        gotoPage,
        setPageSize,
        // Get the state from the instance
        state: { pageIndex, pageSize, sortBy, filters },
    } = useTable({
        columns,
        data,
        getTrProps,
        initialState: { pageIndex: 0 },
        manualSortBy: true,
        manualPagination: true,
        manualFilters: true,
        pageCount: controlledPageCount,
        defaultColumn: { Filter: InputFilter }

    }, useFilters, useSortBy, useExpanded, usePagination );

    React.useEffect(() => {
        const paginationModel = new PaginationModel();
        paginationModel.skip = pageSize * pageIndex;
        paginationModel.take = pageSize;

        const sortByModel = new SortByModel();
        sortByModel.sortBy = sortBy?.length > 0 ? sortBy[0].id : null;
        sortByModel.sortDesc = sortBy?.length > 0 ? sortBy[0].desc : null;

        let urlParams;
        if(hasFilterModel())
        {
            const filtersModel = eval(new filterModel());
            filters.forEach((filterItem) => {
                filtersModel[filterItem.id] = filterItem.value
            });

            urlParams = {
                ...paginationModel,
                ...sortByModel,
                ...filtersModel.getResult()
            };
        }
        else
        {
            urlParams = {
                ...paginationModel,
                ...sortByModel,
            };
        }

        fetchData({ urlParams, pageSize });
    }, [fetchData, pageIndex, pageSize, sortBy, filters]);

    const generateSortingIndicator = column => {
        return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""
    };

    const hasFilterModel = () => {
        return !!filterModel;
    };

    return(
        <React.Fragment>
            <div className="d-flex justify-content-between align-items-end">
                <ReactPaginate
                    previousLabel={t('prev')}
                    nextLabel={t('next')}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    forcePage={pageIndex}
                    onPageChange={(data) => gotoPage(data.selected)}
                    containerClassName={'pagination'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    activeClassName={'active'}
                    breakClassName={'page-link'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'page-link'}
                />

                <div className='form-group'>
                    <label className="col-form-label ">{ t('go-to-page') }</label>
                    <input
                        className='form-control form-control-sm'
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={e => {
                            const page = e.target.value ? Number(e.target.value) - 1 : 0
                            gotoPage(page)
                        }}
                    />
                </div>

                <div className='form-group'>
                    <label className="col-form-label ">{ t('show-count') }</label>
                    <select
                        className="form-control form-control-sm"
                        value={pageSize}
                        onChange={e => {
                            setPageSize(Number(e.target.value))
                        }}
                    >
                        {[5, 10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                {pageSize}
                            </option>
                        ))}
                    </select>
                </div>

            </div>


            <Table bordered striped className="nowrap" {...getTableProps()} responsive>
                <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => {
                            const {show, getHeaderProps} = column;
                            return (
                                show !== false ?
                                    <th {...getHeaderProps()}  className={column.headerClassName ? column.headerClassName : '' } style={column.styleHeader} >
                                        <div {...column.getSortByToggleProps()}>
                                            {t(column.render('Header'))}
                                            {generateSortingIndicator(column)}
                                        </div>
                                        { hasFilterModel() ? (<Filter column={column} />) : (<React.Fragment/>) }
                                    </th> :
                                    <React.Fragment key={false}/>
                            );
                        })}
                    </tr>
                ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                    prepareRow(row);
                    return (
                        <Fragment key={row.getRowProps().key}>
                            <tr>
                                {row.cells.map(cell => {
                                    return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                })}
                            </tr>
                            {row.isExpanded && (
                                <tr>
                                    <td colSpan={visibleColumns.length}>{renderRowSubComponent(row)}</td>
                                </tr>
                            )}
                        </Fragment>
                    );
                })}
                <tr>
                    {loading ? (
                        // Use our custom loading state to show a loading indicator
                        <td colSpan="10000">{t('loading')}...</td>
                    ) : (
                        <td colSpan="10000">
                            { t('table-showing-elements', {pageLength: page.length, pageCount: itemCount}) }
                        </td>
                    )}
                </tr>
                </tbody>
            </Table>
        </React.Fragment>

    )
};
export default withNamespaces()(HilightTableAdvanced);
